import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, Grid, Typography } from '@material-ui/core';
import {
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  orange,
  blueGrey,
} from '@material-ui/core/colors';

const colors = [
  green[500],
  pink[400],
  purple['500'],
  teal['500'],
  blue[400],
  indigo['400'],
  deepPurple[500],
  cyan[500],
  lightBlue[500],
  lightGreen[500],
  lime[800],
  orange[700],
  blueGrey[400],
];

const useStyles = makeStyles(() => ({
  container: {
    padding: '15px',
    // width: '100px',
    position: 'fixed',
    zIndex: '100000',
    right: '25px',
  },
  inch6: {
    color: colors[0],
  },
  inch12: {
    color: colors[1],
  },
  inch18: {
    color: colors[2],
  },
}));

function GraphLegendDesktop() {
  const classes = useStyles();

  return (
    <Card className={classes.container}>
      <Grid container spacing={2} direction="column">
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.inch6}>
            {'6"'}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.inch12}>
            {'12"'}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.inch18}>
            {'18"'}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

export default GraphLegendDesktop;
